import { useSendEmailMutation } from "@features/admin/admin-slice"

interface SendWelcomeEmailProps {
  name: string
  email: string
}

export const useSendWelcomeEmail = () => {
  const [sendEmail] = useSendEmailMutation()

  // send welcome email
  const htmlMessage = (
    name: string
  ) => `<p style='margin:10px 0;'>Hi ${name},</p> <p style='margin:0'>Thanks for creating a <a href='https://www.carpaddy.com' style='color:#23369F;text-decoration:underline' target='_blank' data-saferedirecturl=''>CarPaddy</a> account. 
        								</p> <p style='margin-top:5px'>
        									Like our name suggests, we are your vehicle's best friend and our aim is to take away any headache you may have concerning your car, bus, bike, truck or any other vehicle. </p> <p style='margin-top:5px'>
        									Register your vehicles on the platform and you will automatically get a FREE notification before your vehicle paper expires and we will be in touch to make the process a stress-less one for you, so that with just a click you can sit back and get your car papers right at your home/office. </p> <p style='margin-top:5px'>
        									You can also earn alot of cool cash if you refer friends and contacts to us. To access this referral offer, sign into your account and click the <b>Refer & Earn</b> button on the dashboard. </p> <p style='margin:20px 0 5px 0;height:50px'>
        									<a href='https://app.carpaddy.com/vehicle/add' style='background:#23369F;padding:15px 50px; border-radius:5px; color:#fff;text-decoration:none;font-weight:bold;display:inline-block;text-align:center' target='_blank' data-saferedirecturl=''> Register Your Vehicle </a></p><p style='margin:50px 0 0px 0;color:#8b8b8b'> </p>
        						`
  const sendWelcomeEmail = async ({ name, email }: SendWelcomeEmailProps) =>
    await sendEmail({
      sender_name: "CarPaddy.com",
      sender_email: "support@carpaddy.com",
      to: [email],
      bcc: ["support@carpaddy.com"],
      subject: "It's Good to Have You On-Board",
      htmlMessage: htmlMessage(name),
      // imageUrl:  "",
    })

  return { sendWelcomeEmail }
}
